import { IModalActions, ModalActionType } from 'redux/actions/ModalActions';
import { ModalData } from 'models/ModalData';
import { Reducer } from 'redux';

const initialState: ModalData | null = null;
export const modalDataReducer: Reducer<ModalData | null, IModalActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case ModalActionType.SHOW_MODAL:
                {
                    return action.modalData;
                }
            case ModalActionType.CLOSE_MODAL:
                {
                    let modalData: ModalData = {...state!};
                    modalData.isActive = false;
                    return modalData;
                }
            default:
                return state;
        }
    };
